<script setup>
import {defineEmits, defineProps, onMounted, ref} from "vue";
import axiosApi from "@/utils/axiosApi";
import {ElMessage} from "element-plus";

const prop = defineProps(['show', 'loginAccount','moadio'])
const emit = defineEmits(['sends'])
const sendSms = ref(false);
const loading = ref(false)
const getCodeLoading = ref(false)
const time = ref(0)
let timer;
onMounted(() => {
  sendSms.value = prop.show
  getCode()
})
const smsCode = ref("")
const getCode = () => {
  getCodeLoading.value = true
  new axiosApi({
    encode: "site",
    method: "order/quota",
    body: {
      store_id: 1898,
      amount: 1,
      cust_id: prop.loginAccount.cust_id,
      uid: prop.loginAccount.uid
    }
  }).send((res) => {
    getCodeLoading.value = false
    if (res.message.code !== "000") {
      return ElMessage.error({message: res.message.content})
    }
    time.value = 120
    djs()
  }, () => getCodeLoading.value = false)
}
const djs = () => {
  if (time.value < 1) {
    clearTimeout(timer);
    return
  }
  timer = setTimeout(() => {
    time.value--
    djs()
  }, 1000)
}
const checkSms = () => {
  if (!smsCode.value) return ElMessage.error({message: "请输入验证码！"})
  loading.value = true
  new axiosApi({
    method: "order/sms_check",
    encode: "site",
    body: {
      cust_id: prop.loginAccount.cust_id,
      mobile: prop.loginAccount.phoneNumber,
      code: smsCode.value
    }
  }).send((res) => {
    loading.value = false
    if (res.message.code !== "000") {
      return ElMessage.error({message: res.message.content})
    }
    emit("sends")
  }, () => loading.value = false)
}
</script>

<template>
  <el-dialog v-model="sendSms" destroy-on-close :show-close="false" :close-on-click-modal="false" width="93.7vw"
             class="login-dialog" center>
    <template #header>
      <h3>
        <span style="border-bottom: 3px solid var(--el-color-error)">短信验证</span>
      </h3>
    </template>
    <div class="send-sms">
      <h3>检测当前登录的手机号为</h3>
      <h1>{{ prop.loginAccount.mobile }}</h1>
      <div class="input-sms">
        <el-input placeholder="请输入验证码" v-model="smsCode">
          <template #suffix>
            <el-button :loading="getCodeLoading" :disabled="time > 0" @click="getCode" type="danger" plain>
              {{ time > 0 ? `${time}s后重发` : '获取验证码' }}
            </el-button>
          </template>
        </el-input>
      </div>
      <div class="button">
        <el-button type="danger" round color="#D8000D" size="large" :loading="loading" @click="checkSms"
                   :disabled="smsCode.length < 1">
          确认兑换
        </el-button>
      </div>
    </div>
  </el-dialog>
</template>

<style scoped lang="less">
.send-sms {
  text-align: center;
  line-height: 30px;
  margin: 20px auto;

  h1 {
    margin: 15px auto;
  }
}

.input-sms{
  /deep/ .el-input{
    .el-input__wrapper{
      background-color: #e5e5e5;
      padding: 10px;
    }
  }
  .el-button{
    background: none;
  }
}
</style>
